import React from "react"

import "./Backdrop.scss"

const Backdrop = ({ click }) => <div className="backdrop" onClick={click} />

export default Backdrop
